import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const SESSION_KEY = 'lxra_intro_shown';

function shouldShowIntro() {
  if (typeof window === 'undefined') return false;
  return !window.sessionStorage.getItem(SESSION_KEY);
}

// One-time cinematic logo reveal shown on the visitor's first page load per
// browser session. Skippable via click; auto-dismisses after ~1.6s.
export const IntroLoader = () => {
  const [visible, setVisible] = useState(shouldShowIntro);

  useEffect(() => {
    if (!visible) return;
    sessionStorage.setItem(SESSION_KEY, '1');
    document.body.style.overflow = 'hidden';
    const timer = setTimeout(() => setVisible(false), 1600);
    return () => clearTimeout(timer);
  }, [visible]);

  useEffect(() => {
    if (!visible) document.body.style.overflow = '';
  }, [visible]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="fixed inset-0 z-[200] flex items-center justify-center bg-[#0A0A0A] cursor-pointer"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.55, ease: [0.16, 1, 0.3, 1] }}
          onClick={() => setVisible(false)}
          data-testid="intro-loader"
        >
          <motion.img
            src="/logo-lxra.png"
            alt="LXRA Studios"
            className="h-9 sm:h-11 w-auto"
            initial={{ opacity: 0, scale: 0.88, filter: 'blur(8px)' }}
            animate={{ opacity: 1, scale: 1, filter: 'blur(0px)' }}
            transition={{ duration: 0.85, ease: [0.16, 1, 0.3, 1] }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};
